module.exports = {
  ONLINE: 'online',
  DASHBOARD: 'dashboard'
}
